var __jsx = React.createElement;
import React from "react";
import { ELSTypography } from "components/common/elsevier/Typography/Typography";
import { ELSGrid } from "components/common/elsevier/Grid/Grid";
import styles from "./Layout.module.scss";

/**
 *
 * @param {title} title Indicates title to be set for the document object (browser title)
 * @param {isPublic} isPublic Indicates if the page is public facing
 * @param {children} children Chidren to output in layout "main" element
 * @param {showHeroBanner} showHeroBanner To show the Hero Banner
 *
 * @returns JSX
 */
function Layout(_ref) {
  var showHeroBanner = _ref.showHeroBanner,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(ELSGrid, {
    container: true,
    justifyContent: "center",
    className: styles.conference_series
  }, showHeroBanner && /*#__PURE__*/React.createElement(ELSGrid, {
    className: styles.conference_series__hero_banner,
    container: true,
    columnSpacing: 5,
    maxWidth: "xl"
  }, /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    lg: 3,
    md: 3,
    sm: 12
  }), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    lg: 9,
    md: 9,
    sm: 12
  }, /*#__PURE__*/React.createElement(ELSTypography, {
    component: "h1",
    variant: "h2",
    "data-cy": "confSeriesTitle"
  }, "Browse conference series in Compendex"))), children);
}
export default Layout;